import { milkmanStore } from "../../store/milkmanStore";
import { subscriptionStore } from "../../store/subscriptionStore";
import { deliveryContainer } from "../../mixins/deliveryContainer";
import _ from 'lodash'

export class DeliveryResolver {
    timeRanges = []
    state = {
      loaded: true
    }

    getFrom() {
        let fromArray = [];
          this.getTimeRanges().map((range) => {
              let from = range.from;
              fromArray.push(from);
          });
        return _.uniq(fromArray);
    }
    getTo() {
        let toArray = [];
        this.getTimeRanges().map((range) => {
            let to = range.to;
            toArray.push(to);
        });
        return toArray;
    }

    getToByFrom(from) {
        let toArray = [];
        this.getTimeRanges().map((range) => {
            if (from === range.from) {
                let to = range.to;
                toArray.push(range);
            }
        });
        return toArray;
    }

    getTimeRanges() {
        return this.timeRanges
    }

    when() {
        return true;
    }

    loadTimeRange() {
        deliveryContainer.methods.loadTimeRangeFromDelivery();
    }

    loadBySubscription() {
       
    }

    getPriceRange (start, end) {
      if (!start || !end) {
        return 0;
      }

      let priceRange = this.getToByFrom(start.slice(0, -3)).find(e => {
        return e.to == end.slice(0, -3)
      })

      return priceRange ? priceRange.price : 0
    }
}
